<form class="coverPathForm" id="legalInfoForm" [formGroup]="legalInfoForm">
  <div class="correction-form__label form__label">
    <div class="label-basic__content">{{ headerText }}</div>
    <basic-label displayText="{{ nameFieldText }}"></basic-label>
    <div class="padding-top"></div>
    <radio-group
      [propertyName]="'hasLegal'"
      [valueOptions]="legalOptions"
      formControlName="hasLegal"
      [formGroupComponent]="true"
      (valueChanged)="setLegal()"
    ></radio-group>
  </div>
  <div *ngIf="this.legalInfoForm.get('hasLegal').value === 'true'" class="form form--name-long">
    <div class="line"></div>
    <div class="correction-form__subQuestion">
      <div class="correction-form__label form__label">
        <basic-label displayText="What is your legal name?"></basic-label>
        <div class="padding-top-10"></div>
        <div class="form__inline-field-container">
          <div class="form__field">
            <basic-text-input
              formControlName="legalFirstName"
              [propertyName]="'legalFirstName'"
              [placeholder]="'First Name'"
              [ngClass]="{
                'entry-field--error':
                  legalInfoForm.get('legalFirstName').errors && legalInfoForm.get('legalFirstName').touched
              }"
            ></basic-text-input>
            <control-messages
              class="error-message error-message--entry-field"
              [control]="legalInfoForm.get('legalFirstName')"
            ></control-messages>
          </div>
          <div class="form__field">
            <basic-text-input
              formControlName="legalMiddleName"
              [propertyName]="'legalMI'"
              [placeholder]="'Middle Name'"
              [ngClass]="{
                'entry-field--error':
                  legalInfoForm.get('legalMiddleName').errors && legalInfoForm.get('legalMiddleName').touched
              }"
            ></basic-text-input>
          </div>
          <div class="form__field">
            <basic-text-input
              formControlName="legalLastName"
              [propertyName]="'legalLastName'"
              [placeholder]="'Last Name'"
              [ngClass]="{
                'entry-field--error':
                  legalInfoForm.get('legalLastName').errors && legalInfoForm.get('legalLastName').touched
              }"
            ></basic-text-input>
            <control-messages
              class="error-message error-message--entry-field"
              [control]="legalInfoForm.get('legalLastName')"
            ></control-messages>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="correction-form__label form__label">
    <basic-label displayText="{{ addressText }}"></basic-label>
    <div class="padding-top"></div>
    <radio-group
      [propertyName]="'hasAddress'"
      [valueOptions]="addressOptions"
      formControlName="hasAddress"
      [formGroupComponent]="true"
      (valueChanged)="setAddress()"
    ></radio-group>
  </div>
  <div *ngIf="legalInfoForm.get('hasAddress').value === 'true'" class="form form--address-long">
    <div class="line-address"></div>
    <div class="correction-form__subQuestion">
      <div class="correction-form__label form__label">
        <basic-label displayText="Previous Address"></basic-label>

        <div class="padding-top-10"></div>
        <div class="form--address-long__field--line-1">
          <basic-text-input
            formControlName="street"
            [propertyName]="'street'"
            [placeholder]="'Line 1'"
            [ngClass]="{
              'entry-field--error': legalInfoForm.get('street').errors && legalInfoForm.get('street').touched
            }"
          ></basic-text-input>
          <control-messages
            class="error-message error-message--entry-field"
            [control]="legalInfoForm.get('street')"
          ></control-messages>
        </div>

        <div class="form--address-long__field--line-2">
          <basic-text-input
            formControlName="line1"
            [propertyName]="'line1'"
            [placeholder]="'Line 2'"
            [ngClass]="{
              'entry-field--error': legalInfoForm.get('line1').errors && legalInfoForm.get('line1').touched
            }"
          ></basic-text-input>
        </div>

        <div class="form__inline-field-container">
          <div class="form__field">
            <basic-text-input
              formControlName="city"
              [propertyName]="'verificationCity'"
              [placeholder]="'City'"
              [ngClass]="{
                'entry-field--error': legalInfoForm.get('city').errors && legalInfoForm.get('city').touched
              }"
            ></basic-text-input>
            <control-messages
              class="error-message error-message--entry-field"
              [control]="legalInfoForm.get('city')"
            ></control-messages>
          </div>

          <div class="form__field">
            <basic-text-input
              [placeholder]="'Zip'"
              formControlName="zip"
              [formGroupComponent]="true"
              [ngClass]="{
                'entry-field--error': legalInfoForm.get('zip').errors && legalInfoForm.get('zip').touched
              }"
            ></basic-text-input>
            <control-messages
              class="error-message error-message--entry-field"
              [control]="legalInfoForm.get('zip')"
            ></control-messages>
          </div>

          <div class="form__field">
            <basic-text-input
              formControlName="state"
              [propertyName]="'verificationState'"
              [placeholder]="'State'"
              [isState]="true"
              [ngClass]="{
                'entry-field--error': legalInfoForm.get('state').errors && legalInfoForm.get('state').touched
              }"
            ></basic-text-input>
            <control-messages
              class="error-message error-message--entry-field"
              [control]="legalInfoForm.get('state')"
            ></control-messages>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
<div class="submit-divider"></div>
<div class="padding-top"></div>
<button
  class="correction-form__button button button--primary button--yellow"
  [ngClass]="{ 'button--disabled': shouldBeDisabled() }"
  [disabled]="shouldBeDisabled()"
  (click)="submit()"
>
  Submit
</button>
